import Link from 'next/link'
import type { FunctionComponent } from 'react'

import styles from './sso-button.module.scss'
import type { SsoType } from '@app-types/sso'
import { LinkButton } from '@components/button/link'
import { Apple } from '@components/icons/apple'
import { Google } from '@components/icons/google'
import { Mail } from '@components/icons/mail'
import { TEXT } from '@lib/utils/text'
import { LINK } from '@shared/util/link'

/** Displays a button offering to sign in via an SSO provider */
export const SSOButton: FunctionComponent<React.PropsWithChildren<Props>> = ({
    type,
    next,
}) => {
    const { Icon, ...iconProps } = icons[type]
    return (
        <div className={styles.container}>
            <Link href={LINK.sso(type, next).serialize()}>
                <LinkButton
                    asChild
                    size='medium'
                    className={styles.button}
                    preset='primary'
                >
                    <div className={styles.icon}>
                        <Icon {...iconProps} />
                    </div>
                    {TEXT.sso.button[type]}
                </LinkButton>
            </Link>
        </div>
    )
}

const icons = {
    google: { Icon: Google, height: '18px' },
    apple: { Icon: Apple, height: '19px', color: 'step-white' },
    email: { Icon: Mail, width: '22px', color: 'step-white' },
} as const

interface Props {
    type: SsoType
    /** Redirect here after successful authorization. */
    next?: string
}
